/**
 * @file paddlex 下载 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useState, useEffect} from 'react';
import {fetchGetHistoryInfo} from '../../../../api/pages/paddlexApi';
import {IHistoryVersionData} from '../../components/history-version-table/types';

const usePaddlexHistoryHooks = () => {
    const [historyVersion, setHistoryVersion] = useState<IHistoryVersionData[]>([]);

    useEffect(() => {
        (async () => {
            let res;
            try {
                res = await fetchGetHistoryInfo();
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const pageData = res.body?.result?.pageData ?? {};
                const hv: any[] = Array.isArray(pageData.historyVersion) ? pageData.historyVersion : [];
                setHistoryVersion(hv.map((item, index) => ({
                    key: '' + index,
                    date: item.date,
                    linuxUrl: item.linuxUrl,
                    macUrl: item.macUrl,
                    version: item.version,
                    winUrl: item.winUrl,
                    releaseNoteUrl: item.releaseNoteUrl
                })));
            }
        })();
    }, []);

    return {
        historyVersion
    };
};

export default usePaddlexHistoryHooks;
